// extracted by mini-css-extract-plugin
module.exports = {"flag-icon":"style_flag-icon__1WMtd"};